var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"center"},[_c('p',[_vm._v("联系方式")]),_c('p',[_vm._v("QQ邮箱:1354352923@qq.com")]),_c('p',[_vm._v("电话:15797784918")])])])}]

export { render, staticRenderFns }